import MyClaimFormPageActionTypes from '../actions/my-claim-form-page-action-types';

const initialState = {
  loading: false,
  claim: null,
  validationResult: null,
  uploading: false,
  attachmentId: null,
  attachmentFilename: null,
  uploadError: null,
  isDeleteAttachmentDialogVisible: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_START:
      return {
        ...state,
        loading: true,
        validationResult: null
      };
    case MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_END:
      return {
        ...state,
        loading: false,
        claim: action.payload?.claim ?? null,
        validationResult: action.payload?.validationResult ?? null,
        attachmentId: action.payload?.attachmentId ?? null,
        attachmentFilename: action.payload?.attachmentFilename ?? null
      };
    case MyClaimFormPageActionTypes.UPLOAD_ATTACHMENT_START:
      return {
        ...state,
        uploading: true,
        uploadError: null
      };
    case MyClaimFormPageActionTypes.UPLOAD_ATTACHMENT_END:
      return {
        ...state,
        uploading: false,
        attachmentId: action.payload?.attachmentId || null,
        attachmentFilename: action.payload?.attachmentFilename || null,
        uploadError: action.payload?.uploadError || null
      };
    case MyClaimFormPageActionTypes.TOGGLE_DELETE_ATTACHMENT_DIALOG:
      return {
        ...state,
        isDeleteAttachmentDialogVisible: !state.isDeleteAttachmentDialogVisible
      };
    case MyClaimFormPageActionTypes.DELETE_ATTACHMENT_END:
      return {
        ...state,
        attachmentId: null,
        attachmentFilename: null,
        uploadError: null,
        isDeleteAttachmentDialogVisible: false
      };
    case MyClaimFormPageActionTypes.CLEAR_UPLOAD_ERROR:
      return {
        ...state,
        uploadError: null
      };
    case MyClaimFormPageActionTypes.CLEANUP_MY_CLAIM_FORM_PAGE:
      return initialState;
    default:
      return state;
  }
};
